import {
  Scissors,
  Layers,
  Wind,
  WashingMachine,
  Wallet,
  Stamp,
} from "lucide-react";

/* ---------- Product data ---------- */
export const PRODUCTS = [
  { slug: "menara",     name: "The Menara",     print: "Cedar Bloom",       price: "€189", tag: "NEW",         image: "/yaba_p01.webp", lead: "Ivory canvas with hand-brushed cedar strokes — quiet, confident, unmistakably Marrakech." },
  { slug: "zellige",    name: "The Zellige",    print: "Sapphire Mosaic",   price: "€209", tag: null,          image: "/yaba_p02.webp", lead: "Deep sapphire tessellations, drawn by hand from centuries-old Fes zellige tilework." },
  { slug: "alhambra",   name: "The Alhambra",   print: "Ivory Arabesque",   price: "€199", tag: null,          image: "/yaba_p03.webp", lead: "A delicate ivory arabesque on midnight ground — restrained, ceremonial, easy to wear." },
  { slug: "bouregreg",  name: "The Bouregreg",  print: "River Slate",       price: "€189", tag: null,          image: "/yaba_p04.webp", lead: "River-slate palette in minimalist geometry — inspired by the estuary between Rabat and Salé." },
  { slug: "djemaa",     name: "The Djemaa",     print: "Ember Souk",        price: "€219", tag: "Only 3 left", image: "/yaba_p06.webp", lead: "Ember tones borrowed from Djemaa el-Fna at dusk — warm, alive, a little theatrical." },
  { slug: "riad",       name: "The Riad",       print: "Courtyard Sand",    price: "€199", tag: null,          image: "/yaba_p07.webp", lead: "Warm sand and soft archway motifs, tuned for evenings on a rooftop terrace." },
  { slug: "tafilalt",   name: "The Tafilalt",   print: "Desert Rose",       price: "€199", tag: null,          image: "/yaba_p09.webp", lead: "A rose fade laid over hand-woven cross-hatch — echoes of the palm groves south of Erfoud." },
  { slug: "volubilis",  name: "The Volubilis",  print: "Roman Ochre",       price: "€209", tag: null,          image: "/yaba_p10.webp", lead: "Roman ochre columns from the Volubilis ruins, translated into a modern architectural stripe." },
  { slug: "chefchaouen", name: "The Chefchaouen", print: "Atlas Brushwork", price: "€209", tag: "NEW DROP",   image: "/yaba_p13.webp", lead: "Atlas-blue brushwork on a cream ground — a wearable painting from the Rif mountains." },
  { slug: "essaouira",  name: "The Essaouira",  print: "Sunset Current",    price: "€219", tag: "NEW DROP",    image: "/yaba_p14.webp", lead: "Ocean current in ember and petrol brushwork — cut for the Atlantic wind off Essaouira." },
  { slug: "meknes",     name: "The Meknes",     print: "Indigo Dune",       price: "€199", tag: "NEW DROP",    image: "/yaba_p15.webp", lead: "Indigo shading into dune ochre — a hand-dip effect that fades no two ways alike." },
  { slug: "ourika",     name: "The Ourika",     print: "Cactus Wave",       price: "€219", tag: "NEW DROP",    image: "/yaba_p16.webp", lead: "Deep cactus greens with soft waterway curves — a nod to the valley south of Marrakech." },
  { slug: "ait-ben-haddou", name: "The Aït Ben Haddou", print: "Terracotta Diamonds", price: "€219", tag: "NEW DROP", image: "/yaba_p17.webp", hoverImage: "/yaba_p17_back.webp", lead: "Terracotta diamonds and gold sfifa — cut for the light off the kasbah walls at Aït Ben Haddou." },
  { slug: "toubkal",    name: "The Toubkal",    print: "Atlas Zigzag",      price: "€209", tag: "NEW DROP",    image: "/yaba_p18.webp", lead: "Deep pine green in a hand-drawn chevron — inspired by the ridgelines above Toubkal, the High Atlas' tallest peak." },
  { slug: "ifrane",     name: "The Ifrane",     print: "Cedar Trellis",     price: "€209", tag: "NEW DROP",    image: "/yaba_p19.webp", lead: "Olive and stone interlocking trellis — the shade of the cedar canopy above Ifrane, Morocco's mountain retreat." },
  { slug: "merzouga",   name: "The Merzouga",   print: "Sunset Blockwork",  price: "€229", tag: "NEW DROP",    image: "/yaba_p20.webp", lead: "Modern rust-and-slate blockwork with hand-drawn curves — the way the dunes of Erg Chebbi break at last light near Merzouga." },
];

/* ---------- USP strip ---------- */
export const USPS = [
  { Icon: Scissors,       label: "Handcrafted sfifa",     sub: "Real gold-thread trim, hand-stitched in Fes." },
  { Icon: Layers,         label: "Premium viscose",       sub: "Fluid drape, silk-like touch." },
  { Icon: Wallet,         label: "Deep hidden pockets",   sub: "Phone, passport, keys — invisible." },
  { Icon: WashingMachine, label: "Machine wash friendly", sub: "Cold cycle. No dry-clean tax." },
  { Icon: Wind,           label: "Breathable comfort",    sub: "Loose fit + side-vent airflow." },
  { Icon: Stamp,          label: "Custom prints",         sub: "Limited runs. No two identical." },
];

/* ---------- Announcement bar (rotating) ---------- */
export const ANNOUNCEMENTS = [
  "SS26 Launch Collection — 12 new jellabas",
  "Free worldwide shipping over €200",
  "30-day easy returns, no questions",
  "Handcrafted in Fes, Morocco",
  "Insured DHL Express — tracked door-to-door",
  "Limited runs · no two prints identical",
  "Members: early access to next drop",
];

/* ---------- 3D hotspots ----------
 * position → 3D coords of the brass dot marker.
 * card     → screen-space anchor for the popup (rendered outside the Canvas
 *            so it never gets clipped by the WebGL viewport).
 */
export const HOTSPOTS_3D = [
  { id: "sfifa",   position: [0.05, 1.6, 0.05],  card: { top: "18%", left: "56%" }, title: "Hand-stitched sfifa",  detail: "Real gold-thread trim, sewn in Fes over 6 hours." },
  { id: "pocket",  position: [-0.7, 0.2, 0.05],  card: { top: "36%", left: "42%" }, title: "Deep hidden pocket",   detail: "Fits passport, phone, keys — invisible from outside." },
  { id: "airflow", position: [0.8, -1.2, 0.05],  card: { top: "62%", left: "10%" }, title: "Side-vent airflow",    detail: "Cut for movement and all-day breathability." },
  { id: "print",   position: [0.4, 0.7, 0.05],   card: { top: "30%", left: "8%"  }, title: "Custom print",         detail: "Limited run of 47. No two identical." },
  { id: "wash",    position: [-0.6, -1.5, 0.05], card: { top: "70%", left: "45%" }, title: "Machine wash safe",    detail: "Cold cycle · line dry · zero dry-clean tax." },
];

/* ---------- Lifestyle tiles ---------- */
export const WEAR_TILES = [
  { context: "AT HOME",        sub: "Sunday afternoons, tea, quiet moments.", image: "/yaba_wear_at_home.jpg" },
  { context: "FOR PRAYER",     sub: "Modest, breathable, quietly refined.",   image: "/yaba_wear_for_prayer.jpg" },
  { context: "EVENING EVENTS", sub: "Loafers, linen scarf, brass hour.",      image: "/yaba_wear_evening_events.jpg" },
];

export const NAV = ["Shop", "The Collection", "Craftsmanship", "About", "Contact"];

/* ---------- Reviews (shown on every PDP) ---------- */
export const REVIEWS = [
  {
    name: "Karim R.",
    city: "Paris, FR",
    rating: 5,
    title: "Better than any tailored coat I've owned",
    body: "Wore it to a wedding in Marrakech and got asked where I got it four times. The gold sfifa is real — you can feel it. Hidden pockets fit my phone and passport, no bulge.",
    date: "3 weeks ago",
  },
  {
    name: "Yassine M.",
    city: "Rotterdam, NL",
    rating: 5,
    title: "Finally a jellaba I can machine wash",
    body: "I bought two more within a week. The fit is elegant, not draped. Ships fast, arrives ironed and folded like it's from a boutique — the packaging alone is a gift.",
    date: "1 month ago",
  },
  {
    name: "Amine S.",
    city: "Casablanca, MA",
    rating: 4,
    title: "Elegant and warm without being heavy",
    body: "The viscose really does drape like silk. Only knocked a star because I'd have loved a slimmer XL — I sized down to L and it fits perfectly. Will buy again for Eid.",
    date: "2 months ago",
  },
];

export const RATING_DISTRIBUTION = [
  { stars: 5, pct: 89 },
  { stars: 4, pct: 8 },
  { stars: 3, pct: 2 },
  { stars: 2, pct: 1 },
  { stars: 1, pct: 0 },
];
